export const getContrastColor = (hexColor): string => {
  return parseInt(hexColor.substring(1), 16) > 0xffffff / 2 ? "black" : "white";
};
